import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import download from 'downloadjs';

export default {
	name: 'BulkAllocateShipmentRuleToClientComponent',
	components: {
		VueElementLoading,
		download
	},
	data: function() {
		return {
			createdBy:"",
			isLoadingUpload :false,
			fileDetails:[],
      selectedFile:{},
      configFile:'',
      failedEntries:[]
		}
	},
	created: function() {},
	computed: {},
	filters: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.createdBy = userdetail[0].email;
	},
	methods: {

	  addBulkClientRule(event){
  		this.selectedFile = event.target[1].files[0];
			this.failedEntries = [];

			if(this.selectedFile.size>5242880){
				this.$alertify.error("Failed! Upload Max File Size Should Not Be Greater Than 5 MB"); return false;

  		}else if ( /\.(csv)$/i.test(this.selectedFile.name)){
				this.isLoadingUpload = true;

      	const fd = new FormData();
				fd.append('lastModifiedBy', this.createdBy);
				fd.append('fileData', this.selectedFile);
				fd.append('fileName', this.selectedFile.name);

      	axios.post(apiUrl.api_url_hubops + 'addBulkClientRule', fd,
      	{
        	headers: {
          	'Authorization': 'authkey xB84JJ89Hd25'
        	}
      	})
      	.then(result => {

        	if(result.data.ResultCode == 100){
						this.failedEntries = result.data.failed;
          	this.$alertify.success(result.data.ReturnMessage);
						this.resetForm();
        	}else{
						this.$alertify.error(result.data.ReturnMessage);
					}

					this.isLoadingUpload= false;
      	}, error => {
        	console.error(error)
        	this.isLoadingUpload= false;
        	this.$alertify.error('Error Occured');
   		 	});
    	}else{
      	this.isLoadingUpload= false;
      	this.$alertify.error("Failed! Please Upload Only Valid Format: .csv");
    	}
    },

	  onUploadSubmit: function(result) {
			console.log(result);
			this.$validator.validateAll().then((result) => {
				if(result){
					this.addBulkClientRule(event);
					event.target.reset();
				}
			}).catch((err) => {
				console.log(err);
			  this.$alertify.error('Error Occured');
			});
	  },

		async exportFailedConfig() {
     this.isLoadingUpload = true;

		 let csvFields = {'Client': 'Client'};
		 let data = {'Client': ''};

		 let fileName = 'AllocateShipmentRuleToClient_Template';

		 this.isLoadingUpload = true;
		 await axios({
			 method: 'GET',
			 'url': apiUrl.api_url_hubops + 'fetchShipmentRules',
			 'data': ({}),
			 headers: {
				 'authorization': 'authkey xB84JJ89Hd25'
			 }
		 })
		 .then(result => {
			 result.data.ResponseData.map(item=>{
				 csvFields[item.rulename] = item.rulename;
				 data[item.rulename] = '';
       })
		 }, error => {
			 console.error(error)
			 this.$alertify.error('Error Occured');
		 })

		 await this.jsonToCSV(fileName, [data], csvFields);
     this.isLoadingUpload = false;
   	},

		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = ''
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      data.map(function(item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },

		export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },

    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },

	  resetForm(event){
			this.isLoadingUpload = false;
      this.configFile= '';
			this.$validator.reset();
			this.errors.clear();
	  }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BulkAllocateShipmentRuleToClient/BulkAllocateShipmentRuleToClient.js